import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useForm } from "react-hook-form";

import Globals from "../../utility/constants/appConstants";
import ecommEndpoints from "../../utility/features/endPoints/ecommEndpoints";
import OverlayLoader from "../loader/overlayLoader";
import BaseClient from "../../utility/apiClients/base/baseClient";
import forgotPwdCSS from "../../styles/login.module.scss";
import styles from "../../styles/forgotpasword.module.scss";
import Storage from "../../utility/features/helpers/storageHelper";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const labels = Globals.forgotpassword;

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [errorText, setErrorText] = useState("");
    const [labelsData] = useState(Globals.globalError || {});
    const [isError, setIsError] = useState(false);
    const [isSuccess, setSuccess] = useState(false);
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { put } = BaseClient();

    const onSubmit = async ({ email: submittedEmail }) => {
        setIsLoading(true);
        setIsError(false);
        setErrorText("");
        try {
            const response = await put(
                process.env.REACT_APP_ECOMM_URL + ecommEndpoints.forgotPassword(),
                { email: submittedEmail },
                false
            );
            const responseData = JSON.parse(response?.data);
            const responseCode = Number(response?.code ?? responseData?.code);
            const responseMessage = response?.message ?? responseData?.message;
            if(response.status === 500){
                setErrorText("Internal Server Error. Please try again later.");
                setIsError(true);
                setSuccess(false);
                return;
            }

            if (response?.data === "No Account Found") {
                setErrorText(response.data);
                setIsError(true);
                setSuccess(false);
            } else if (responseCode === 20006){
                setErrorText(responseMessage);
                setSuccess(false);
            } else {
                setEmail(submittedEmail);
                setErrorText("");
                setSuccess(true);
                Storage.forgotPasswordEmail(submittedEmail);

                navigate("/login");
            }
        } catch (error) {
            console.error(error);
            setIsError(true);
            setErrorText("Something went wrong. Please try again.");
            setSuccess(false);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading && <OverlayLoader isOpen={isLoading} />}
            {isError && (
                <div className={styles.errorBanner} role="alert">
                    <div className={styles.errorInner}>
                        <img
                            src="/images/MyAccount/error-notification-icon.png"
                            alt=""
                            className={styles.errorIcon}
                            aria-hidden="true"
                        />
                        <div className={styles.errorTextBlock}>
                            <div className={styles.errorTitle}>{errorText}</div>
                            <div className={styles.errorMessage}>
                                {labelsData.GenericError}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Main container */}
            <div className={`container ${forgotPwdCSS["commercial-login"]}`}>
                <div className="row">
                    <div className={`col-md-6 mx-auto ${forgotPwdCSS["login-bg"]}`}>
                        <div className={styles.forgotLayout}>
                            {/* Left: header + form column */}
                            <div>
                                <div className={forgotPwdCSS["login-head"]}>
                                    <h1>{labels.forgotHeading}</h1>
                                    <span className="d-inline-block gfs-20 gfw-3 mb-24 text-dark">
                                        {labels.forgotSubheading}
                                    </span>
                                </div>

                                <div className={forgotPwdCSS["login-form"]}>
                                    <form onSubmit={handleSubmit(onSubmit)} noValidate>
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                id="email"
                                                className={`${styles["form-control"]}`}
                                                placeholder={labels.usernameField}
                                                {...register("email", {
                                                    required: "Email is required",
                                                    pattern: {
                                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                        message: "Invalid email format",
                                                    },
                                                })}
                                                autoComplete="on"
                                            />
                                            {errors.email && (
                                                <span className={forgotPwdCSS["errorMsg"]}>
                                                    {errors.email.message}
                                                </span>
                                            )}
                                            {errorText && (
                                                <span className={forgotPwdCSS["errorMsg"]} dangerouslySetInnerHTML={{ __html: errorText }}></span>
                                            )}
                                        </div>

                                        <button
                                            type="submit"
                                            className={`btn ${forgotPwdCSS["login-btn"]} ${forgotPwdCSS["btn-primary"]}`}
                                        >
                                            {labels.forgotPasswordButton}
                                        </button>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
